/*
  Cloud 10 bag drawer + bag page (Oct 2026)
  - Delivery message as one line with a bar (drawer and bag page)
  - Free samples screen in the drawer: tap to add / tap again to remove, "Done" goes back
  - Bag page: slim checkout bar pinned to the bottom of the screen once the top CHECK OUT scrolls away
  Markup: snippets/cart-drawer.liquid, sections/main-cart-items.liquid. Styles: c10-bag.css
*/
(function () {
  'use strict';
  if (window.__c10bag) return;
  window.__c10bag = true;

  /* ---------- delivery line ---------- */

  function cents(v) { var n = parseInt(v, 10); return isNaN(n) ? null : n; }

  // Reads the hidden data the theme's shipping-threshold section outputs and rewrites the box as
  // "€X away from free delivery" + a bar. The theme rewrites the box on every bag change, so this runs
  // again each time (see watch()).
  function formatDelivery(box) {
    if (!box) return;
    var data = box.querySelector('.shipping__thresold');
    if (!data) {
      // no free-delivery threshold for this country, or not loaded yet
      if (!box.querySelector('.skeleton-box') && !box.querySelector('.c10-ship')) box.classList.add('c10-ship-none');
      return;
    }
    var total = cents(data.getAttribute('data-cart-value'));
    var target = cents(data.getAttribute('data-thresold-number'));
    var more = data.getAttribute('data-spend-more') || '';
    if (total === null || !target) return;
    var pct = Math.max(0, Math.min(100, (total / target) * 100));
    var done = total >= target;
    var text = done ? 'You’ve got free delivery' : more + ' away from free delivery';
    box.classList.remove('c10-ship-none');
    box.innerHTML =
      '<div class="c10-ship' + (done ? ' is-done' : '') + '">' +
        '<p class="c10-ship-text">' + text + '</p>' +
        '<div class="c10-ship-bar" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Progress towards free delivery"><i style="width:' + pct.toFixed(1) + '%"></i></div>' +
      '</div>';
  }

  function formatAllDelivery() {
    formatDelivery(document.querySelector('#CartDrawer .free__delivery__banner'));
    var pageBox = document.querySelector('#cart-shipping-bar .shipping_content');
    if (pageBox) {
      formatDelivery(pageBox);
      var bar = document.getElementById('cart-shipping-bar');
      if (bar) bar.classList.add('c10-ship-host');
    }
  }

  /* ---------- free samples screen (drawer) ---------- */

  var changed = false;
  var busy = false;

  function picker() { return document.querySelector('#CartDrawer [data-c10d-picker]'); }

  function setMsg(text) {
    var m = document.querySelector('#CartDrawer [data-c10d-msg]');
    if (m) m.textContent = text;
  }

  function refreshPickerState() {
    var p = picker();
    if (!p) return;
    var allowed = parseInt(p.getAttribute('data-allowed'), 10) || 0;
    var inBag = p.querySelectorAll('.c10d-sample.is-on').length;
    // samples already in the bag that aren't one of the 6 shown still count towards the limit
    var extra = Math.max(0, (parseInt(p.getAttribute('data-in'), 10) || 0) - (parseInt(p.getAttribute('data-shown-in'), 10) || 0));
    var count = inBag + extra;
    var c = p.querySelector('[data-c10d-count]');
    if (c) c.textContent = count + ' of ' + allowed + ' added';
    p.querySelectorAll('.c10d-sample').forEach(function (b) {
      var full = count >= allowed && !b.classList.contains('is-on');
      b.classList.toggle('is-full', full);
    });
    return { allowed: allowed, count: count };
  }

  function openPicker() {
    var p = picker();
    if (!p) return;
    if (!p.hasAttribute('data-shown-in')) p.setAttribute('data-shown-in', p.querySelectorAll('.c10d-sample.is-on').length);
    changed = false;
    p.hidden = false;
    refreshPickerState();
    setMsg('Tap a sample to add it to your bag');
    var first = p.querySelector('.c10d-back');
    if (first) first.focus();
  }

  function closePicker() {
    var p = picker();
    if (p) p.hidden = true;
    if (changed) {
      changed = false;
      var drawer = document.querySelector('cart-drawer');
      // reloads the drawer contents (items, samples line, total) the same way the theme does when it opens
      if (drawer && typeof drawer.updateShipping === 'function') drawer.updateShipping();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'c10-samples' }); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('bogos:gifts'));
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function toggleSample(btn) {
    if (busy || btn.disabled) return;
    var state = refreshPickerState();
    var id = parseInt(btn.getAttribute('data-c10d-sample'), 10);
    var name = (btn.querySelector('.c10d-sample-name') || {}).textContent || 'Sample';
    var on = btn.classList.contains('is-on');
    if (!on && state && state.count >= state.allowed) {
      setMsg('You’ve added all your free samples. Tap one to remove it first.');
      return;
    }
    busy = true;
    btn.classList.add('is-busy');
    var req = on ? post('/cart/change.js', { id: String(id), quantity: 0 }) : post('/cart/add.js', { items: [{ id: id, quantity: 1 }] });
    req.then(function () {
      btn.classList.toggle('is-on', !on);
      btn.setAttribute('aria-pressed', on ? 'false' : 'true');
      changed = true;
      setMsg((on ? 'Removed ' : '✓ Added ') + name.trim() + (on ? '' : ' to your bag'));
    }).catch(function (err) {
      setMsg((err && (err.description || err.message)) || 'Sorry, that sample couldn’t be added.');
    }).then(function () {
      busy = false;
      btn.classList.remove('is-busy');
      refreshPickerState();
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : e.target.parentElement;
    if (!t || !t.closest) return;
    if (t.closest('[data-c10d-samples-open]')) { e.preventDefault(); openPicker(); return; }
    if (t.closest('[data-c10d-samples-done]')) { e.preventDefault(); closePicker(); return; }
    var s = t.closest('[data-c10d-sample]');
    if (s) { e.preventDefault(); toggleSample(s); }
  });

  // closing the drawer (×, overlay, Escape, Continue shopping) also closes the samples screen
  document.addEventListener('keyup', function (e) {
    if (e.key === 'Escape') { var p = picker(); if (p && !p.hidden) closePicker(); }
  });

  /* ---------- bag page: pinned checkout bar ---------- */

  function stickyBar() {
    if (!document.body.classList.contains('template-cart')) return;
    var top = document.querySelector('.c10b-top');
    if (!top || document.getElementById('c10b-sticky')) return;
    var bar = document.createElement('div');
    bar.id = 'c10b-sticky';
    bar.className = 'c10b-sticky';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<span class="c10b-sticky-total"><b data-c10b-total></b><small data-c10b-count></small></span>' +
      '<button type="submit" form="cart" name="checkout" class="button c10-checkout" tabindex="-1">Check out</button>';
    document.body.appendChild(bar);

    function sync() {
      var v = document.querySelector('.c10b-top .totals__subtotal-value');
      var n = document.querySelector('.c10b-top [data-c10b-items]');
      bar.querySelector('[data-c10b-total]').textContent = v ? v.textContent.trim() : '';
      bar.querySelector('[data-c10b-count]').textContent = n ? n.textContent.trim() : '';
    }
    sync();
    new MutationObserver(sync).observe(top, { childList: true, subtree: true, characterData: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        var empty = !!document.querySelector('cart-items.is-empty');
        bar.classList.toggle('is-on', out && !empty);
        document.body.classList.toggle('c10b-sticky-on', out && !empty);
        bar.setAttribute('aria-hidden', out && !empty ? 'false' : 'true');
        bar.querySelector('button').tabIndex = out && !empty ? 0 : -1;
      }).observe(top.querySelector('.c10-checkout') || top);
    }
  }

  /* ---------- watch for the theme re-rendering things ---------- */

  var pending = null;
  function soon() {
    clearTimeout(pending);
    pending = setTimeout(formatAllDelivery, 30);
  }

  function watch() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer) new MutationObserver(function (list) {
      // ignore our own rewrite of the delivery box
      for (var i = 0; i < list.length; i++) {
        var n = list[i].target;
        if (n.closest && n.closest('.c10-ship')) continue;
        if (n.classList && n.classList.contains('free__delivery__banner') && n.querySelector('.c10-ship')) continue;
        soon();
        return;
      }
    }).observe(drawer, { childList: true, subtree: true });

    var page = document.getElementById('cart-shipping-bar');
    if (page) new MutationObserver(function () {
      var box = page.querySelector('.shipping_content');
      if (box && box.querySelector('.shipping__thresold')) soon();
    }).observe(page, { childList: true, subtree: true });
  }

  /* ---------- bag page: folded rows remember being open ---------- */
  // picking a sample on the bag page reloads the page, so keep the samples row open afterwards
  function rememberRows() {
    var rows = document.querySelectorAll('details.c10b-row-samples');
    rows.forEach(function (d) {
      try { if (sessionStorage.getItem('c10b-samples-open') === '1') d.open = true; } catch (e) {}
      d.addEventListener('toggle', function () {
        try { sessionStorage.setItem('c10b-samples-open', d.open ? '1' : '0'); } catch (e) {}
      });
    });
  }

  /* ---------- bag page: samples row wording follows the bag total ---------- */
  // the theme refreshes the samples box after each quantity change; this keeps the row heading in step
  function syncSamplesRow() {
    var d = document.querySelector('details.c10b-row-samples');
    if (!d) return;
    var a = d.querySelector('#allowedSample');
    var allowed = a ? parseInt(a.textContent, 10) || 0 : 0;
    var added = d.querySelectorAll('.grid-item.active').length;
    d.hidden = allowed < 1;
    var t = d.querySelector('[data-c10b-samples-title]');
    var n = d.querySelector('[data-c10b-samples-note]');
    if (t) t.textContent = allowed > 1 ? 'Choose ' + allowed + ' free samples' : 'Choose your free sample';
    if (n) n.textContent = added >= allowed && allowed > 0 ? '✓ Added to your bag' : 'On us, with your order';
  }

  function watchSamplesRow() {
    var body = document.querySelector('details.c10b-row-samples .c10b-row-body');
    if (!body) return;
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(syncSamplesRow, 50); })
      .observe(body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- bag page: discount code ---------- */
  // Applies the code to the bag straight away (Shopify checks it) and says whether it worked.
  function discountRow() {
    var row = document.querySelector('[data-c10b-discount-row]');
    if (!row) return;
    var input = row.querySelector('.c10b-discount-input');
    var btn = row.querySelector('[data-c10b-discount-apply]');
    var msg = row.querySelector('[data-c10b-discount-msg]');
    var note = row.querySelector('[data-c10b-discount-note]');
    var same = function (a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); };

    function showApplied(codes) {
      var ok = (codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
      if (ok.length && note) note.textContent = '✓ ' + ok.join(', ') + ' applied';
    }

    // already applied codes (e.g. after the page reloads)
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { showApplied(c.discount_codes); }).catch(function () {});
    try {
      if (sessionStorage.getItem('c10b-discount-open') === '1') { row.open = true; sessionStorage.removeItem('c10b-discount-open'); }
    } catch (e) {}

    function apply() {
      var code = (input.value || '').trim();
      if (!code) { msg.textContent = 'Please enter a code.'; input.focus(); return; }
      btn.disabled = true;
      msg.textContent = 'Checking…';
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
        .then(function (cart) {
          var keep = (cart.discount_codes || []).map(function (c) { return c.code; }).filter(function (c) { return !same(c, code); });
          return post('/cart/update.js', { discount: keep.concat(code).join(',') });
        })
        .then(function (cart) {
          var hit = (cart.discount_codes || []).filter(function (c) { return same(c.code, code); })[0];
          if (hit && hit.applicable) {
            msg.textContent = '✓ ' + hit.code + ' applied';
            try { sessionStorage.setItem('c10b-discount-open', '1'); } catch (e) {}
            location.reload(); // shows the new prices and total
            return;
          }
          msg.textContent = 'Sorry, ' + code + ' can’t be used with the items in your bag.';
          btn.disabled = false;
          // take the code that didn't work back off, keep any that did
          var good = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
          post('/cart/update.js', { discount: good.join(',') }).catch(function () {});
        })
        .catch(function () {
          msg.textContent = 'Sorry, something went wrong. You can also enter your code at checkout.';
          btn.disabled = false;
        });
    }

    btn.addEventListener('click', apply);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(); } });
  }

  function start() {
    formatAllDelivery();
    watch();
    stickyBar();
    rememberRows();
    syncSamplesRow();
    watchSamplesRow();
    discountRow();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
